import { render, staticRenderFns } from "./AddWarehouseModal.vue?vue&type=template&id=f6f33060"
import script from "./AddWarehouseModal.vue?vue&type=script&lang=js"
export * from "./AddWarehouseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports